import { render, staticRenderFns } from "./ChristmasTreeIcon.vue?vue&type=template&id=45a0c18c&scoped=true&lang=pug"
import script from "./ChristmasTreeIcon.vue?vue&type=script&lang=js"
export * from "./ChristmasTreeIcon.vue?vue&type=script&lang=js"
import style0 from "./ChristmasTreeIcon.vue?vue&type=style&index=0&id=45a0c18c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a0c18c",
  null
  
)

export default component.exports